import { Box, OutlinedInput, Typography } from '@mui/material';
import {
  calcAmountInput,
  calcLabel,
  currencyTextInfo,
  customStylesFlag,
  selectBoxCurrency,
} from 'app/pages/HomePage/CurrencyBox/CurrencyBox.sx';
import Select from 'react-select';
import { IconOption } from 'app/components/SelectOption';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  value: {
    value: string;
    label: JSX.Element;
    buy: string;
    sell: string;
    text: string;
  };
  secondValue: {
    value: string;
    label: JSX.Element;
    buy: string;
    sell: string;
    text: string;
  };
  valueInput: string;
  onChangeInput: (e: any, from: any, to: any) => void;
  onChange: (newValue: any) => void;
  title: string;
  options: any[];
  bankType: string;
}
const CalcAmountSelect = (props: Props) => {
  const { value, onChange, title, options, bankType, secondValue, valueInput, onChangeInput } = props;
  const { t } = useTranslation();
  const convertor = +value.sell / +secondValue.buy;

  return (
    <>
      <Typography sx={calcLabel}>{title}</Typography>
      <Box sx={selectBoxCurrency}>
        <OutlinedInput
          type={'text'}
          placeholder={t('homePage.amount')}
          sx={calcAmountInput}
          value={valueInput}
          onChange={(e) => onChangeInput(e.target.value, undefined, undefined)}
        />
        <Select
          styles={customStylesFlag}
          isSearchable={false}
          components={{
            IndicatorSeparator: () => null,
            Option: IconOption,
          }}
          options={options}
          hideSelectedOptions={false}
          menuPortalTarget={document.body}
          value={value}
          onChange={onChange}
        />
      </Box>
      <Typography sx={currencyTextInfo}>{`1 ${value.value} = ${
        value.value === secondValue.value ? 1 : convertor.toFixed(4)
      } ${secondValue.value}`}</Typography>
    </>
  );
};

export default CalcAmountSelect;
